export const getModifiedUrl = (url: string) => {
  const baseUrl = "https://tienda.nelo.mx/mx/"
  const match = url.match(/mx\/(.*)/)
  return match ? baseUrl + match[1] : url
}
